import { Box, Stack, Typography } from "@mui/material"
import { alpha } from "@mui/material/styles"
import type { FC } from ".."
import { Link, ResponsiveImage, SvgIcon } from ".."
import StyledContainer from "./StyledContainer"
import filmFestivalGlobals from "./assets/filmFestivalGlobals.json"

const SponsorAdBlock: FC = () => {
  const randomImageUrl = `https://picsum.photos/971/250?random=${Math.random()}`

  const image = {
    variants: [
      {
        width: 971,
        height: 250,
        url: randomImageUrl,
        title: "",
        alt: "test",
        style: "default",
      },
    ],
  }

  return (
    <Box
      sx={(theme) => ({
        bgcolor: theme.palette["neutral.700"].main,
        position: "relative",
        zIndex: 3,
        borderTop: "1px solid rgba(243, 234, 210, 0.10)",
      })}
    >
      <StyledContainer maxWidth={1400} variant="secondary">
        <Box
          sx={(theme) => ({
            padding: { xs: theme.spacing(12, 4), md: theme.spacing(22, 4) },
            transition: theme.transitions.create(["padding"]),
            display: "flex",
            justifyContent: "center",
          })}
        >
          <Box
            width={{ xs: "300px", md: "971px" }}
            height={{ xs: "250px", md: "250px" }}
            flexShrink={0}
            sx={(theme) => ({
              position: "relative",
              borderRadius: theme.spacing(4),
              overflow: "hidden",
            })}
          >
            <ResponsiveImage
              image={image}
              sx={(theme) => ({
                width: "100%",
                height: "100%",
                objectFit: "cover",
                borderRadius: theme.spacing(4),
              })}
            />
            <Box
              sx={(theme) => ({
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                backgroundColor: "#FF8F52",
                mixBlendMode: "overlay",
                opacity: 0.4,
                borderRadius: theme.spacing(4),
              })}
            />
          </Box>
        </Box>
      </StyledContainer>
    </Box>
  )
}

export default SponsorAdBlock
